<template>
    <div :class="$style.infoBanner">
        <div :class="$style.infoBannerTextWrapper">
            <div :class="$style.infoBannerHeader">
                <p :class="$style.infoBannerHeader">Fair hires, fairer future</p>
                <div :class="$style.mobileOnly" @click="toggleInfoBannerState">
                    <FontAwesomeIcon :icon="chevronIcon" />
                </div>
            </div>
            <div v-show="isInfoBannerOpen">
                <p :class="$style.infoBannerContent">
                    At Applied, we're on a mission to reshape the future, one hire at a time. We
                    empower organisations to eliminate unconscious bias from their hiring process,
                    creating a level playing field for candidates. Say goodbye to traditional
                    credentials and hello to a world that values your skills.
                </p>
            </div>
        </div>
    </div>
</template>

<script>

import { faChevronDown, faChevronUp } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

export default {
    name: 'InfoBanner',
    components: {
        FontAwesomeIcon,
    },
    data() {
        return {
            isInfoBannerOpen: true,
            chevronIcon: faChevronUp,
        }
    },
    methods: {
        toggleInfoBannerState() {
            this.isInfoBannerOpen = !this.isInfoBannerOpen
            this.chevronIcon = this.isInfoBannerOpen ? faChevronUp : faChevronDown
        },
    },
}

</script>

<style module src="./InfoBanner.css" />
